<template>
  <div class="chained-selectors-container">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12  mb-3">
        <label for="superClientSelect" class="form-label">Selecciona un Super Cliente:</label>
        <div class="input-group custom-input-group">
          <input
            type="text"
            class="form-control custom-selector-input"
            :class="{'is-invalid': !selectedSuperClient && superClientSearchTerm && !loading && noSuperClientResults && superClientSearchTerm !== ''}"
            v-model="superClientSearchTerm"
            @focus="openSuperClientDropdown"
            @blur="closeSuperClientDropdown"
            @input="filterSuperClients"
            placeholder="Escribe o selecciona un Super Cliente..."
            autocomplete="off"
            aria-label="Super Cliente"
          />
          <button
            class="btn btn-outline-secondary custom-dropdown-toggle"
            type="button"
            @click="toggleSuperClientDropdown"
            aria-expanded="false"
          >&#9660;</button>
           <button
              class="btn btn-outline-secondary custom-clear-button"
              type="button"
              @click="clearSuperClient"
              v-if="selectedSuperClient || superClientSearchTerm"
            >
              &times;
            </button>
        </div>

        <div class="custom-selector-list-wrapper" v-show="isSuperClientDropdownOpen && !loading">
          <ul class="list-group custom-selector-list">
            <li
              class="list-group-item custom-list-item"
              v-for="client in limitedFilteredSuperClients"
              :key="client.codigo"
              @mousedown.prevent="selectSuperClient(client)"
            >
              <strong class="item-name">{{ client.nombre }}</strong>
              <span class="item-code">({{ client.codigo }})</span>
            </li>
            <li v-if="hasMoreSuperClientResults" class="list-group-item custom-more-results-message">
              Mostrando {{ displayLimit }} de {{ filteredSuperClientsCount }} resultados. Refina tu búsqueda.
            </li>
          </ul>
          <div v-if="noSuperClientResults && !loading && superClientSearchTerm !== ''" class="custom-no-results-message">
            No se encontraron super clientes.
          </div>
          <div v-else-if="loading && superClientSearchTerm === ''" class="custom-loading-message">
            Cargando super clientes...
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-6 col-sm-12 mb-3">
        <label for="nitSelect" class="form-label">Selecciona un NIT:</label>
        <div class="input-group custom-input-group">
          <input
            type="text"
            class="form-control custom-selector-input"
            :class="{'is-invalid': !selectedNitData && nitSearchTerm && !loading && noNitResults && nitSearchTerm !== ''}"
            v-model="nitSearchTerm"
            :disabled="!selectedSuperClient"
            @focus="openNitDropdown"
            @blur="closeNitDropdown"
            @input="filterNits"
            placeholder="Escribe o selecciona un NIT..."
            autocomplete="off"
            aria-label="NIT"
          />
          <button
            class="btn btn-outline-secondary custom-dropdown-toggle"
            type="button"
            @click="toggleNitDropdown"
            :disabled="!selectedSuperClient"
            aria-expanded="false"
          >&#9660;</button>
           <button
              class="btn btn-outline-secondary custom-clear-button"
              type="button"
              @click="clearNit"
              v-if="selectedNitData || nitSearchTerm"
            >
              &times;
            </button>
        </div>

        <div class="custom-selector-list-wrapper" v-show="isNitDropdownOpen && !loading">
           <ul class="list-group custom-selector-list">
            <li
              class="list-group-item custom-list-item"
              v-for="nit in limitedFilteredNits"
              :key="nit.nit"
              @mousedown.prevent="selectNit(nit)"
            >
              <strong class="item-name">{{ nit.nombre }}</strong>
              <span class="item-code">({{ nit.nit }})</span>
            </li>
            <li v-if="hasMoreNitResults" class="list-group-item custom-more-results-message">
              Mostrando {{ displayLimit }} de {{ filteredNitsCount }} resultados. Refina tu búsqueda.
            </li>
          </ul>
          <div v-if="noNitResults && !loading && nitSearchTerm !== '' && selectedSuperClient" class="custom-no-results-message">
            No se encontraron NITs para este super cliente.
          </div>
           <div v-else-if="loading && nitSearchTerm === ''" class="custom-loading-message">
            Cargando NITs...
          </div>
        </div>
      </div>
    </div>

    <!--MOSTRABA el objeto selecionado -->
    <!-- <div v-if="resultObject" class="mt-4 p-3 bg-light border rounded">
      <h5>Resultado:</h5>
      <pre>{{ JSON.stringify(resultObject, null, 2) }}</pre>
    </div>
    -->
    <div v-if="loading && superClientSearchTerm === ''" class="text-center mt-3">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando datos principales...</span>
      </div>
      <p class="text-muted mt-2">Cargando datos principales...</p>
    </div>
    <div v-if="error" class="alert alert-danger mt-3" role="alert">
      Error al cargar los datos: {{ error }}
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";

export default {
  data() {
    return {
      superClients: [], // Ahora contendrá toda la estructura con los 'nits' anidados

      selectedSuperClientCode: '',
      selectedSuperClient: null, // Objeto completo del super cliente seleccionado

      selectedNit: '',
      selectedNitData: null,     // Objeto completo del NIT seleccionado

      superClientSearchTerm: '',
      nitSearchTerm: '',

      isSuperClientDropdownOpen: false,
      isNitDropdownOpen: false,

      loading: false, // Ahora solo se usará para la carga inicial de superClientes con sus nits
      error: null,
      resultObject: null,
      displayLimit: 200,
    };
  },
  computed: {
    filteredSuperClients() {
      if (!this.superClientSearchTerm) {
        return this.superClients;
      }
      const lowerCaseSearchTerm = this.superClientSearchTerm.toLowerCase();
      return this.superClients.filter(
        (client) =>
          client.nombre.toLowerCase().includes(lowerCaseSearchTerm) ||
          client.codigo.toLowerCase().includes(lowerCaseSearchTerm)
      );
    },
    limitedFilteredSuperClients() {
      return this.filteredSuperClients.slice(0, this.displayLimit);
    },
    filteredSuperClientsCount() {
        return this.filteredSuperClients.length;
    },
    hasMoreSuperClientResults() {
        return this.filteredSuperClientsCount > this.displayLimit;
    },
    noSuperClientResults() {
        return this.isSuperClientDropdownOpen && this.filteredSuperClientsCount === 0;
    },

    filteredNits() {
      // Si no hay un super cliente seleccionado, no hay NITs para filtrar
      if (!this.selectedSuperClient || !this.selectedSuperClient.nits) {
        return [];
      }

      // Los NITs se obtienen directamente del selectedSuperClient
      const nitsForSelectedClient = this.selectedSuperClient.nits;
      const nitsArray = Array.isArray(nitsForSelectedClient)
        ? nitsForSelectedClient
        : [nitsForSelectedClient];

      if (!this.nitSearchTerm) {
        return nitsArray;
      }
      const lowerCaseSearchTerm = this.nitSearchTerm.toLowerCase();
      return nitsArray.filter(
        (nit) =>
          nit.nombre.toLowerCase().includes(lowerCaseSearchTerm) ||
          nit.nit.toLowerCase().includes(lowerCaseSearchTerm)
      );
    },
    limitedFilteredNits() {
      return this.filteredNits.slice(0, this.displayLimit);
    },
    filteredNitsCount() {
        return this.filteredNits.length;
    },
    hasMoreNitResults() {
        return this.filteredNitsCount > this.displayLimit;
    },
    noNitResults() {
        return this.isNitDropdownOpen && this.filteredNitsCount === 0;
    }
  },
  watch: {
    selectedSuperClient: {
      handler(newClient) {
        if (newClient) {
          this.superClientSearchTerm = `${newClient.nombre} (${newClient.codigo})`;
          this.selectedSuperClientCode = newClient.codigo;
          // Ya no necesitamos fetchNitsForSuperClient, los nits ya están en newClient.nits
        } else {
          this.superClientSearchTerm = '';
          this.selectedSuperClientCode = '';
        }
        this.clearNitSelection();
        this.updateResultObject();
      },
      deep: true,
    },
    selectedNitData: {
      handler(newNit) {
        if (newNit) {
          this.nitSearchTerm = `${newNit.nombre} (${newNit.nit})`;
          this.selectedNit = newNit.nit;
        } else {
          this.nitSearchTerm = '';
          this.selectedNit = '';
        }
        this.updateResultObject();
      },
      deep: true,
    },
  },
  created() {
    this.refresh();
  },
  methods: {
    /**
     * Carga todos los super clientes con sus NITs anidados en una única llamada.
     */
    async refresh() {
      this.loading = true;
      this.error = null;
      try {
        // La llamada real a tu servicio
        DynamicService.postActionList('cat', 'super-cliente', 'obtener_informacion')
        .then(response => {
          this.superClients = response.data; // Asigna toda la estructura recibida
        });
        this.loading = false;
      } catch (err) {
        this.error = err.message || 'Error desconocido al cargar los datos de super clientes.';
        this.loading = false;
        console.error('Error al cargar datos con DynamicService:', err);
      }
    },
    // --- Métodos para Super Cliente ---
    openSuperClientDropdown() {
      this.isSuperClientDropdownOpen = true;
    },
    closeSuperClientDropdown() {
      setTimeout(() => {
        const activeElement = document.activeElement;
        const isClickingInsideComponent = this.$el.contains(activeElement);
        if (!isClickingInsideComponent) {
          this.isSuperClientDropdownOpen = false;
          if (this.superClientSearchTerm && !this.selectedSuperClient) {
            const foundClient = this.superClients.find(client =>
                client.codigo === this.selectedSuperClientCode ||
                `${client.nombre} (${client.codigo})` === this.superClientSearchTerm
            );
            if (!foundClient) {
                this.clearSuperClient();
            } else {
                this.selectSuperClient(foundClient);
            }
          } else if (!this.superClientSearchTerm && this.selectedSuperClient) {
            this.clearSuperClient();
          }
        }
      }, 150);
    },
    toggleSuperClientDropdown() {
      this.isSuperClientDropdownOpen = !this.isSuperClientDropdownOpen;
      if (this.isSuperClientDropdownOpen && !this.superClientSearchTerm) {
        this.selectedSuperClient = null;
      }
    },
    filterSuperClients() {
      if (this.selectedSuperClient &&
          this.superClientSearchTerm !== `${this.selectedSuperClient.nombre} (${this.selectedSuperClient.codigo})`) {
        this.selectedSuperClient = null;
      }
      if (!this.superClientSearchTerm) {
        this.selectedSuperClient = null;
      }
      this.isSuperClientDropdownOpen = true;
    },
    selectSuperClient(client) {
      this.selectedSuperClient = client;
      this.isSuperClientDropdownOpen = false;
    },
    clearSuperClient() {
      this.selectedSuperClient = null;
      this.selectedSuperClientCode = '';
      this.superClientSearchTerm = '';
      this.clearNitSelection();
      this.isSuperClientDropdownOpen = false;
      this.resultObject = null;
    },

    // --- Métodos para NIT ---
    openNitDropdown() {
      if (this.selectedSuperClient) {
        this.isNitDropdownOpen = true;
      }
    },
    closeNitDropdown() {
      setTimeout(() => {
        const activeElement = document.activeElement;
        const isClickingInsideComponent = this.$el.contains(activeElement);
        if (!isClickingInsideComponent) {
          this.isNitDropdownOpen = false;
          if (this.nitSearchTerm && !this.selectedNitData) {
            const foundNit = this.filteredNits.find(nit =>
                nit.nit === this.selectedNit ||
                `${nit.nombre} (${nit.nit})` === this.nitSearchTerm
            );
            if (!foundNit) {
                this.clearNit();
            } else {
                this.selectNit(foundNit);
            }
          } else if (!this.nitSearchTerm && this.selectedNitData) {
            this.clearNit();
          }
        }
      }, 150);
    },
    toggleNitDropdown() {
      if (this.selectedSuperClient) {
        this.isNitDropdownOpen = !this.isNitDropdownOpen;
        if (this.isNitDropdownOpen && !this.nitSearchTerm) {
          this.selectedNitData = null;
        }
      }
    },
    filterNits() {
      if (this.selectedNitData &&
          this.nitSearchTerm !== `${this.selectedNitData.nombre} (${this.selectedNitData.nit})`) {
        this.selectedNitData = null;
      }
      if (!this.nitSearchTerm) {
        this.selectedNitData = null;
      }
      this.isNitDropdownOpen = true;
    },
    selectNit(nit) {
      this.selectedNitData = nit;
      this.isNitDropdownOpen = false;
    },
    clearNit() {
      this.clearNitSelection();
      this.isNitDropdownOpen = false;
      this.updateResultObject();
    },
    clearNitSelection() {
      this.selectedNitData = null;
      this.selectedNit = '';
      this.nitSearchTerm = '';
    },

    // --- Métodos de Lógica General ---
    updateResultObject() {
      if (this.selectedSuperClient && this.selectedNitData) {
        this.resultObject = {
          nombre: this.selectedNitData.nombre,
          direccion: this.selectedNitData.direccion,
          nit: this.selectedNitData.nit,
          super_cliente: this.selectedSuperClient.codigo,
          email: this.selectedNitData.email,
        };
        this.$emit('super-selected', this.resultObject);
      } else {
        this.resultObject = null;
        this.$emit('super-selected', null);
      }
    },
  },
};
</script>

<style scoped>
/* Contenedor principal del componente: ocupará el ancho disponible */
.chained-selectors-container {
  width: 100%; /* Ocupa todo el ancho del padre */
  padding: 20px;
  box-sizing: border-box; /* Incluye padding en el ancho total */
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #f9f9f9;
}

/* Grupo de Input (input + botones) */
.custom-input-group {
  display: flex;
  width: 100%; /* Asegura que ocupe todo el ancho de la columna */
  position: relative; /* Para posicionar correctamente el valid feedback */
}

/* Input de texto */
.custom-selector-input {
  flex-grow: 1; /* El input crece para ocupar el espacio */
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border-top-right-radius: 0; /* Bordes unidos a los botones */
  border-bottom-right-radius: 0;
}

.custom-selector-input:focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Clase de Bootstrap para inputs inválidos (sin importar imágenes SVG) */
.custom-selector-input.is-invalid {
  border-color: #dc3545;
}


/* Botones de toggle y limpiar */
.custom-dropdown-toggle,
.custom-clear-button {
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  background-color: transparent;
  border: 1px solid #ced4da;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.custom-dropdown-toggle:hover,
.custom-clear-button:hover {
  color: #212529;
  background-color: #e2e6ea;
  border-color: #dae0e5;
}

/* Ajustes de bordes para los botones en el input-group */
.custom-input-group .custom-dropdown-toggle {
  border-left: none; /* Se une con el input */
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  z-index: 1; /* Asegura que no sea cubierto por el input */
}

.custom-input-group .custom-clear-button {
  color: #dc3545; /* Rojo para el icono de limpiar */
  font-size: 1.25rem; /* Más grande para la 'x' */
  line-height: 1;
  padding: 0.375rem 0.6rem; /* Ajuste para la 'x' */
  border-left: 1px solid #ced4da; /* Separador entre toggle y clear */
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}


/* Contenedor de la lista desplegable */
.custom-selector-list-wrapper {
  position: absolute;
  top: 100%; /* Debajo del input */
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-top: none;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  overflow: hidden; /* Asegura que el contenido no se salga */
}

/* Lista de opciones */
.custom-selector-list {
  max-height: 250px; /* Altura máxima para la lista */
  overflow-y: auto; /* Scroll si hay más elementos que el max-height */
  list-style: none; /* Elimina viñetas */
  padding: 0;
  margin: 0;
}

.custom-list-item {
  padding: 10px 15px; /* Espaciado interno generoso */
  border-bottom: 1px solid #eee; /* Separador sutil */
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.95rem; /* Tamaño de fuente ligeramente más grande */
  color: #343a40; /* Color de texto predeterminado */
}

.custom-list-item:hover {
  background-color: #f1f3f5; /* Color más claro al pasar el ratón */
}

.custom-list-item:last-child {
  border-bottom: none; /* Sin borde en el último elemento */
}

.item-name {
  flex-grow: 1; /* El nombre ocupa la mayor parte del espacio */
  font-weight: 600; /* Negrita para el nombre */
  color: #212529; /* Color de texto más oscuro para el nombre */
  margin-right: 10px;
  word-break: break-word; /* Rompe palabras largas para evitar desbordamiento */
}

.item-code {
  flex-shrink: 0; /* El código no se encoge */
  font-size: 0.85em; /* Tamaño más pequeño para el código */
  color: #6c757d; /* Gris para el código */
  text-align: right;
  white-space: nowrap; /* Evita que el código se rompa en varias líneas */
}

/* Mensajes de estado (no resultados, cargando, más resultados) */
.custom-no-results-message,
.custom-loading-message,
.custom-more-results-message {
  padding: 0.75rem 1.25rem;
  font-size: 0.875em;
  color: #6c757d;
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
  text-align: center;
}

.custom-more-results-message {
  font-style: italic;
  color: #007bff; /* Color azul de Bootstrap para enlaces */
}

/* Indicadores de carga y error */
.spinner-border {
  width: 2rem;
  height: 2rem;
  margin-bottom: 0.5rem;
}

.alert {
  font-size: 0.9em;
  padding: 0.75rem 1.25rem;
}

pre {
  background-color: #e9ecef;
  padding: 15px;
  border-radius: 5px;
  overflow-x: auto;
  white-space: pre-wrap;
}
</style>